export var SDK_VERSION = '6.16.1';
//# sourceMappingURL=version.js.map